import { createFileRoute } from "@tanstack/react-router";
import { ProductForm } from "@/components/admin/product-form";

export const Route = createFileRoute("/admin/produtos/novo")({
  component: NovoProdutoPage,
});

function NovoProdutoPage() {
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-eg-dark mb-6">Novo Produto</h1>
      <ProductForm />
    </div>
  );
}
